import {call, put, select} from "@redux-saga/core/effects";
import request from "../../../helpers/request";
import {downloadEnrolmentsCsv} from "../../../../api";
import deltas from "../../../../redux/actions/deltas";
import sharedDownloadStates from "../../../../redux/states/sharedDownloadStates";

const {setDownloadEnrolmentsCsvState} = deltas.actionCreators;
const {LOADING, NOT_LOADING} = sharedDownloadStates;

const filename = () => {
    const now = new Date();

    return `enrolments-${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.csv`;
};

const pad = text => text.toString().padStart(2, '0');

export default function* downloadCsv(){
    yield put(setDownloadEnrolmentsCsvState(LOADING));

    const columnsToHide = yield select(state => state.enrolmentsGrid.columnsToHide);
    const state = yield select();

    let sorters = [];

    for (const [key, value] of Object.entries(state.enrolmentsGrid.sorters)) {
        sorters.push([value['column'], value['direction']]);
    }
    const sortersJSON = JSON.stringify(sorters);

    let filters = Object.entries(state.enrolmentsGrid.filters);

    const filtersJSON = JSON.stringify(filters);

    const { response } = yield call(request, downloadEnrolmentsCsv, {
        notificationOnError: {
            generateMessage: (msg) => `CSV download failed: ${msg}`
        }
    }, {}, null, {
        columnsToHide: columnsToHide.join(','),
        sortInstructions: sortersJSON,
        filterInstructions: filtersJSON,
    });

    if (!response) {
        yield put(setDownloadEnrolmentsCsvState(NOT_LOADING));
        return;
    }

    yield call(handleBlobDownload, response.data);

    yield put(setDownloadEnrolmentsCsvState(NOT_LOADING));
}

function* handleBlobDownload(blob) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `enrolments-${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, 100);
}
